export const requestDetailSlr = (state) => state.requestsReducer.requestsDetails.requestDetailState;
export const requestToCompleteSlr = (state) => state.requestsReducer.requestsDetails.requestToCompleteState;
export const documentToCompleteSlr = (state) => state.requestsReducer.requestsDetails.documentToCompleteState;
export const removeDocFileStateSlr = (state) => state.requestsReducer.requestsDetails.removeDocFileState;


